export const LOADING_FACTORCRITERION = "LOADING_FACTORCRITERION";
export const SAVE_LOADING_FACTORCRITERION = "SAVE_LOADING_FACTORCRITERION";
export const GET_FACTORCRITERION = "GET_FACTORCRITERION";
export const FORM_FAIL = "FORM_FAIL";
export const FACTORCRITERION_FAIL = "FACTORCRITERION_FAIL";
export const GET_FACTORCRITERION_BY_ID = "GET_FACTORCRITERION_BY_ID";

//factores
export const LOADING_FACTOR = "LOADING_FACTOR";
export const SAVE_LOADING_FACTOR = "SAVE_LOADING_FACTOR";
export const GET_FACTOR = "GET_FACTOR";
export const FACTOR_FAIL = "FACTOR_FAIL";

//criterios
export const LOADING_CRITERION = "LOADING_CRITERION";
export const SAVE_LOADING_CRITERION = "SAVE_LOADING_CRITERION";
export const GET_CRITERION = "GET_CRITERION";
export const CRITERION_FAIL = "CRITERION_FAIL";

//funciones
export const LOADING_TASK = "LOADING_TASK";
export const SAVE_LOADING_TASK = "SAVE_LOADING_TASK";
export const GET_TASK = "GET_TASK";
export const TASK_FAIL = "TASK_FAIL";
